import React, { Fragment } from "react";

import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import {
    PLACEHOLDER_IMG_360x360_URL,
    PLACEHOLDER_IMG_360x360_ERROR_URL,
    IMG_BG_COLOR,
} from "../../config";
import StatusChip from "./StatusChip";
import KeyValue from "../display/KeyValue";
import { fromUnixtime } from "../../utils/time";
import ListItem from "../display/ListItem";
import { activityUrl, activityDestinationUrl } from "../../utils/url";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        //backgroundColor: "#212121",
        marginTop: theme.spacing(1),
    },
    img: {
        width: 200,
        height: 110,
        margin: "auto",
        objectFit: "cover",
        backgroundColor: IMG_BG_COLOR,
    },
}));

export default function ResultGrid({ activity }) {
    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <ListItem
                header={
                    <Fragment>
                        <Link
                            color="inherit"
                            href={activityUrl(activity.productCode, activity.name, true)}
                            target="_blank"
                            underline="none"
                            variant="subtitle2"
                        >
                            {`${activity.name} (${activity.productCode})`}
                        </Link>
                    </Fragment>
                }
                contentLeft={
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        height="100%"
                        style={{ marginTop: 10 }}
                    >
                        <Box>
                            <img
                                className={classes.img}
                                alt=""
                                src={!!activity.imageUrl ? activity.imageUrl : PLACEHOLDER_IMG_360x360_URL}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
                                }}
                            />
                        </Box>
                        <Typography
                            variant="caption"
                            display="block"
                            color="textSecondary"
                            gutterBottom
                        >
                            {activity.type}
                        </Typography>
                        <Box>
                            <StatusChip status={activity.status} />
                        </Box>
                        <Typography
                            variant="caption"
                            display="block"
                            color="textSecondary"
                            gutterBottom
                        >
                            {`First Fetch - ${fromUnixtime(activity.firstFetchedOn)}`}
                        </Typography>
                        <Typography
                            variant="caption"
                            display="block"
                            color="textSecondary"
                            gutterBottom
                        >
                            {`Last Fetch - ${fromUnixtime(activity.lastFetchedOn)}`}
                        </Typography>
                        <Typography
                            variant="caption"
                            display="block"
                            color="textSecondary"
                            gutterBottom
                        >
                            {`Fetch Count - ${activity.fetchCount}`}
                        </Typography>
                    </Box>
                }
                contentRight={
                    <Fragment>
                        <KeyValue
                            keyName="Destination"
                            value={<Link
                                href={activityDestinationUrl(activity.destinationId, activity.destinationName, true)}
                                underline="none"
                                target="_blank"
                            >
                                {`${activity.destinationName} (${activity.destinationId})`}
                            </Link>}
                        />
                        <KeyValue
                            keyName="Description"
                            value={activity.description}
                        />
                        <KeyValue
                            keyName="Supplier"
                            value={activity.supplierName}
                        />
                        <KeyValue
                            keyName="Created / Updated in Viator"
                            value={`${fromUnixtime(activity.createdOnViator)} / ${fromUnixtime(activity.updatedOnViator)}`}
                        />
                        <KeyValue
                            keyName="Viator URL"
                            value={<Link
                                href={activity.viatorUrl}
                                underline="none"
                                target="_blank"
                            >
                                {`Open in Viator`}
                            </Link>}
                        />
                    </Fragment>
                }
            />
        </Paper>
    )
}
